import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Airport } from '../../models/airport';

import { FormGroup, FormsModule } from '@angular/forms';
import { UserDesks } from '../../models/user-desks';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgClass } from '@angular/common';
import { ButtonComponent } from '../button/button.component';

// export enum FlightListSelectorDialogAction {
//   submit = 0,
//   cancel
// }

// export interface FlightListSelectorDialogResult {
//   action: FlightListSelectorDialogAction;
//   data: UserDesks;
// }

@Component({
    selector: 'emt-station-selector-dialog',
    templateUrl: './station-selector-dialog.component.html',
    styleUrls: ['./station-selector-dialog.component.scss'],
    imports: [
        NgSelectComponent,
        FormsModule,
        NgClass,
        ButtonComponent,
    ],
})
export class StationSelectorDialogComponent {
  public modalTitle = '';
  public stations: Airport[];
  public selectedStations: string[];
  //#endregion

  //#region Inputs
  @Input() name: string;
  //#endregion

  //#region Constructor
  constructor(public activeModal: NgbActiveModal) {}

  submitDialog() {
    this.activeModal.close(this.selectedStations);
  }

  cancelDialog() {
    this.activeModal.close();
  }
}
